import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 9l3 3l-3 3","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-1"}]]

const IconCircleChevronRight = createReactComponent('outline', 'circle-chevron-right', 'CircleChevronRight', __iconNode);

export default IconCircleChevronRight;